import type { Notification } from 'entities/notification';

export const isNotificationRead = (notification: Notification) => {
  return notification.attributes.isRead;
};
